import { render, staticRenderFns } from "./WholeGenomeSequencingConsentContainer.vue?vue&type=template&id=bd30df78"
import script from "./WholeGenomeSequencingConsentContainer.vue?vue&type=script&lang=js"
export * from "./WholeGenomeSequencingConsentContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports